module.exports = __webpack_public_path__ + "assets/a4ea1332ebabfa5c383784e8989c4032.png";